export const CDN_IMAGES = {
  indstocksLogo:
    'https://indcdn.indmoney.com/public/images/fe/ind_stocks_logo.svg',
  indstocksLogoDark:
    'https://indcdn.indmoney.com/public/images/fe/ind_stocks_logo_dark.svg',
  indmoneyRoundLogo:
    'https://indcdn.indmoney.com/cdn/images/fe/ind-money-logo.svg',
  indmoneyLogo:
    'https://indcdn.indmoney.com/public/ind-marketing/indmoney-weblogo.png',
  indGlobalLogo: 'https://indcdn.indmoney.com/cdn/images/fe/indglobal-logo.png',
  twoColumnLayout:
    'https://indcdn.indmoney.com/cdn/images/fe/two_columns_icon.svg',
  mindBotLogo: 'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_logo.png',
  mindBotRoundLogo:
    'https://indcdn.indmoney.com/cdn/images/fe/mind_round_icon_new.png',
  mindBotLogoDark:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_logo_dark.png',
  mindBotNewChat:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_new_chat.png',
  mindBotMinimize:
    'https://indcdn.indmoney.com/cdn/images/fe/mindbot_minimize_web.png',
  flashIcon: 'https://indcdn.indmoney.com/cdn/images/fe/flash_icon.svg',
  tradingViewIcon: 'https://indcdn.indmoney.com/cdn/images/fe/trading_view.svg',
  flashTradingIcon:
    'https://indcdn.indmoney.com/cdn/images/fe/flash_trading_icon.svg',
  optionChainIcon:
    'https://indcdn.indmoney.com/cdn/images/fe/option_chain_icon.svg',
  flashApiIcon: 'https://indcdn.indmoney.com/cdn/images/fe/flash-api.svg',
  openApiIcon:
    'https://indcdn.indmoney.com/cdn/images/fe/indmoney_open_api.svg',
}

export const BELL_ICON =
  'https://indcdn.indmoney.com/public/fe/images/bell_small.png'
